import { createActions } from 'reduxsauce';

var _createActions = createActions({
  changeLatLon: ['position'],
  setLoaded: ['loaded'],
  setLocated: ['located'],
  setSource: ['source'],
  changePreferredLocation: ['preferredLocation'],
  toggleChangeModal: ['active'],
  toggleChangeNoLocationModal: function toggleChangeNoLocationModal(active) {
    return {
      type: 'LOCATION_TOGGLE_CHANGE_NO_LOCATION_MODAL',
      active: active
    };
  },
  setMapActive: ['mapActive'],
  locationFinderErr: function locationFinderErr(err) {
    return {
      type: 'LOCATION_LOCATION_FINDER_ERR',
      err: err,
      receivedAt: Date.now()
    };
  },
  setTripPlannerLoc: ['tripPlannerLoc'],
  savePathInfo: ['pathInfo'],
  flipModified: [],
  changeZipCode: function changeZipCode(zipcode) {
    return {
      type: 'LOCATION_CHANGE_ZIP_CODE',
      zipcode: zipcode
    };
  },
  changeTripPlanner: function changeTripPlanner(tripPlannerAddress) {
    return {
      type: 'LOCATION_CHANGE_TRIP_PLANNER',
      tripPlannerAddress: tripPlannerAddress
    };
  },
  setLocation: function setLocation(location) {
    return {
      type: 'LOCATION_SET_LOCATION',
      location: location,
      waitlistId: location === null || location === void 0 ? void 0 : location.storeuid
    };
  },
  requestLocations: ['position'],
  requestZipcodes: ['position'],
  requestFromUrl: function requestFromUrl(address) {
    return {
      type: 'LOCATION_REQUEST_FROM_URL',
      address: address
    };
  },
  requestFromUrlVendorid: function requestFromUrlVendorid(vendoridobj) {
    return {
      type: 'LOCATION_REQUEST_FROM_URL_ID',
      vendoridobj: vendoridobj
    };
  },
  receiveLocations: function receiveLocations(json, geoLocated, geoIp) {
    return {
      type: 'LOCATION_RECEIVE_LOCATIONS',
      mapResults: json.data.results,
      results: json.data.results,
      receivedAt: Date.now(),
      geoLocated: geoLocated,
      geoIp: geoIp
    };
  },
  setUserModifiedAction: function setUserModifiedAction(userModified) {
    return {
      type: 'LOCATION_SET_USER_MODIFIED_ACTION',
      userModified: userModified
    };
  },
  receiveAdditionalLocations: function receiveAdditionalLocations(json) {
    return {
      type: 'LOCATION_RECEIVE_ADDITIONAL_LOCATIONS',
      results: json.data.results,
      receivedAt: Date.now()
    };
  },
  receiveLatLon: function receiveLatLon(json, source) {
    return {
      type: 'LOCATION_RECEIVE_LAT_LON',
      // position: json.data.results, // TODO :: RE-ENABLE
      source: source,
      receivedAt: Date.now()
    };
  },
  requestLocationLatLon: {
    type: 'LOCATION_REQUEST_LOCATION_LAT_LON'
  },
  receiveError: {
    type: 'LOCATION_RECEIVE_ERROR'
  }
}, {
  prefix: 'LOCATION_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};